import { Waypoints } from "./Waypoints";

export default Waypoints;
